import { render, staticRenderFns } from "./valueDown.vue?vue&type=template&id=4a3ebf79&"
import script from "./valueDown.vue?vue&type=script&lang=ts&"
export * from "./valueDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports